import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/deploy/apps/front/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/deploy/apps/front/src/components/MapEmbad.tsx");
